<div class="flex flex-col items-center justify-center w-full h-full page-wrap">
  <div class="flex size-font-weight-regular items-center justify-center error-icon">
    <img src="/svgs/global-error-icon.svg" alt="error icon" />
  </div>
  <h1 class="text-headline-sm-weight-semibold text-[1.25rem] mt-100-rem">Access denied - Error 403</h1>
  <div class="flex flex-col justify-center items-center w-full font-normal text-body-md">
    <p>You don't have permission to view this page.</p>

    <p class="text-body-md-weight-regular text-[0.875rem] mt-100-rem text-center w-md">
      To gain access, please either contact an administrator or check that you are signed in with
      the correct account.
    </p>
  </div>
</div>
